import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TestView } from './TestView';
import { TestViewMobile } from './TestViewMobile';
import { ImportView } from './ImportView';
import { HistoryView } from './HistoryView';
import { withWidth, isWidthDown } from '@material-ui/core';

//-----------------------------------------------------------------

class Content extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {

        const { width } = this.props;
        const isMobile = window.matchMedia("(max-width:1200px)").matches;


        return (

            (this.props.activePage == 0) ? (isWidthDown('lg', width) ? <TestViewMobile /> : <TestView />) : ((this.props.activePage == 1) ? <HistoryView /> : <ImportView />)
        );


    }

}



////-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    return {
        viewSimulationActive: state.content.viewSimulationActive,
        viewArchiveActive: state.content.viewArchiveActive,
        activePage: state.interaction.activePage,
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
        onShowSimulationView: () => { dispatch({ type: "CONTENT:SHOW_SIMULATION" }) },
        onShowArchiveView: () => { dispatch({ type: "CONTENT:SHOW_ARCHIVE" }) },
    };

}


const ContentWidth = withWidth()(Content);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ContentWidth);


